// let quantityBreakRender = true;
// const observer = new MutationObserver((mutations, obs) => {
//     let quantityBreak = document.querySelector(".quantity-breaks-now-wrapper");
//     if (quantityBreak) {
//         console.log("apped quantity-breaks-now-wrapper");
//         quantityBreak.style.maxHeight = null;
//         let toggler = document.querySelector(".toggleVolumnDiscount");
//         quantityBreak.parentNode.insertBefore(toggler,quantityBreak);
//         if(quantityBreakRender == false)
//         {
//           toggler.classList.add("active");
//           document.querySelector(".offer-loading").style.display = "none";
//           quantityBreak.style.maxHeight = quantityBreak.scrollHeight + "px";
//           quantityBreakRender = true;
//         }
//         obs.disconnect(); // Stop observing once found
//     }
    
// });

// observer.observe(document.body, { childList: true, subtree: true });
// const toggleVolumnDiscount = document.querySelector(".toggleVolumnDiscount");
// if (toggleVolumnDiscount) {
//   toggleVolumnDiscount.addEventListener("click", function() {
//     if(document.querySelector(".quantity-breaks-now-wrapper") != null)
//     {
//       this.classList.toggle("active");
//       if (document.querySelector(".quantity-breaks-now-wrapper").style.maxHeight) {
//         document.querySelector(".quantity-breaks-now-wrapper").style.maxHeight = null;
//       } else {
//         document.querySelector(".quantity-breaks-now-wrapper").style.maxHeight = document.querySelector(".quantity-breaks-now-wrapper").scrollHeight + "px";
//       }
//     }
//     else
//     {
//       this.classList.toggle("active");
//       quantityBreakRender = false;
//       document.querySelector(".offer-loading").style.display = "block";
//     }
//   });
// }

function getDiscountTiers(){
  const rows = document.querySelectorAll(".quantity-breaks-now-discount-table tr");
  const tiers = [];

  rows.forEach( row => {
    const tds = row.querySelectorAll("td");
    if(tds.length >= 2)
    {
      let qty = parseInt(tds[0].innerText.trim());
      let discount = parseInt(tds[1].innerText.replace("%","").trim());

      if(!isNaN(qty) && !isNaN(discount))
      {
        tiers.push({qty,discount:discount});
      }
    }
  });

  tiers.sort((a, b) => a.qty - b.qty);
  return tiers;

}


function getApplicableDiscount(qty, tiers) {
  let applied = 0;

  tiers.forEach(tier => {
    if (qty >= tier.qty) {
      applied = tier.discount; // highest valid discount
    }
  });

  return applied;
}


function updateDynamicPrice(qty){
  const priceEl = document.querySelector(".product__price .money--last");
  const backEngraveCheckbox = document.querySelector("#second-side-checkbox");
  const basePrice = parseFloat(priceEl.dataset.basePrice);
  const symbol = priceEl.dataset.symbol;

  const tier = getDiscountTiers();

  const discountPercentage = getApplicableDiscount(qty,tier);

  let finalPrice = basePrice * qty * (1 - discountPercentage / 100);

  if(backEngraveCheckbox != null)
  {
    if(backEngraveCheckbox.checked )
    {
      let engravePrice = parseFloat(backEngraveCheckbox.dataset.price);
      finalPrice = finalPrice + (engravePrice * qty);
    }
  }
  

  priceEl.textContent = `${symbol}${finalPrice.toFixed(2)}`;
}

function initQuantityHandlers(){
  const quantityBox = document.querySelector(".product-quantity-input");
  const minusBtn = document.querySelector("#sub");
  const plusBtn = document.querySelector("#add");

  if(!quantityBox || !minusBtn || !plusBtn) return;

  // Observe discount table and update price;

  const observer = new MutationObserver((mutations, obs) => {
      let quantityBreak = document.querySelector(".quantity-breaks-now-wrapper");
      if (quantityBreak) {
          let initQty = document.querySelector(".product-quantity-input").value;
          updateDynamicPrice(initQty);
          obs.disconnect(); // Stop observing once found
      }
      
  });

  observer.observe(document.body, { childList: true, subtree: true });

  plusBtn.addEventListener("click",()=>{
    console.log(quantityBox.value);
    let quantityValue = parseInt(quantityBox.value || 1) + 1;
    updateDynamicPrice(quantityValue)
  });

  minusBtn.addEventListener("click", ()=>{
    let val = parseInt(quantityBox.value || 1);
    if(val > 1){ 
      let quantityValue = val - 1;
      updateDynamicPrice(quantityValue);
    }
    
  });

  quantityBox.addEventListener("input", ()=>{
    let quantityValue = quantityBox.value;
    updateDynamicPrice(quantityValue);
  });

  if( document.querySelector("#second-side-checkbox") != null)
  {
    document.querySelector("#second-side-checkbox").addEventListener("change",()=>{
      let quantityValue = quantityBox.value;
      updateDynamicPrice(quantityValue);
    });
  }
  
}

document.addEventListener("DOMContentLoaded", initQuantityHandlers);

